// extracted by mini-css-extract-plugin
export default {"userPostsContent":"UserPosts_userPostsContent__th9+F","cardContainer":"UserPosts_cardContainer__z3g7p"};